import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DiscountScheme, DiscountSchemeCreate, DiscountSchemeFilter } from '../data/discountScheme';

export function createDiscountSchemeService(client: AxiosInstance) {
  return createCrudService<DiscountScheme, DiscountSchemeCreate, DiscountSchemeFilter>(
    client,
    '/master-data/DiscountScheme',
    'id',
  );
}

export type DiscountSchemeService = CrudService<DiscountScheme, DiscountSchemeCreate, DiscountSchemeFilter>;
